export const user = {
  strict: true, // true => strict update state from component

  state: {
    cover: window.$commin.user.cover,
    lang: window.$commin.user.lang,
    country: window.$commin.user.country,
    timezone: window.$commin.user.timezone,
    timezone_code: window.$commin.user.timezone_code,
    id: window.$commin.user.member_id,
    rule_checked: window.$commin.user.rule_checked,
  },

  getters: {},

  mutations: {
    SET_COVER: (state, payload) => {
      console.log('stored cover [' + payload + ']');
      state.cover = payload;
    },
    SET_LANG: (state, payload) => {
      console.log('stored lang [' + payload + ']');
      state.lang = payload;
    },
    SET_COUNTRY: (state, payload) => {
      console.log('stored country [' + payload + ']');
      state.country = payload;
    },
    SET_TIMEZONE: (state, payload) => {
      console.log('stored timezone [' + JSON.stringify(payload) + ']');
      state.timezone = payload.tz;
      state.timezone_code = payload.code;
    },
    SET_RULE_CHECKED: (state, payload) => {
      console.log('stored rule_checked [' + JSON.stringify(payload) + ']');
      state.rule_checked = true;
      state.country = payload.country;
      state.timezone = payload.timezone;
      state.timezone_code = payload.timezone_code;
    },
  },

  actions: {},
};
